import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    CardImg,
    Card,
} from "reactstrap";
import styles from './styles.module.scss';
import Marquee from "react-fast-marquee";

export default function Clients({
    global,
    pathPrefix,
    heading,
    customClass = "",
    all_clients
}) {
    return (
        all_clients.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    <div className="content-wrapper rounded-3 pt-5 pb-5">
                        <h2 className="text-center heading mb-5">
                            <SourceFlowText global={global} path={`${pathPrefix}.heading`}>{heading}</SourceFlowText>
                        </h2>
                        <Marquee
                            className="mb-md-4 mt-4"
                            speed={60}>
                            {all_clients?.map((post, index) => (
                                <Card className="bg-transparent" key={index}>
                                    <CardImg
                                        className="rounded-0 position-relative ps-5 pe-5 ms-3 me-3"
                                        src={post.image}
                                        alt={post.title}
                                    />
                                </Card>
                            ))}
                        </Marquee>
                    </div>
                </Container>
            </section>
        )
    )
}